import React, { useEffect } from "react";
import Popup from "reactjs-popup";
import { PopupActions, PopupProps } from "reactjs-popup/dist/types";
import closeIconImage from "../../../assets/img/close.svg";
import "reactjs-popup/dist/index.css";
import "./popup.scss";
import Cross from "../Icons/Cross";

interface IPopupProps {
  visible: boolean;
  children: React.ReactNode;
  onClickClose?: () => void;
  showCloseBtn?: boolean;
  closeIconType?: string;
  customRefProp?: React.RefObject<PopupActions>;
  closeOnDocumentClick?: boolean;
  popUpClass?: string;
  customWidth?: string | number;
}

interface ICustomPopup extends PopupProps, IPopupProps {}

const PopupModal: React.FC<ICustomPopup> = ({
  children,
  visible,
  onClickClose,
  showCloseBtn = true,
  closeIconType = "default",
  customRefProp,
  closeOnDocumentClick = false,
  popUpClass,
  customWidth = "650px",
  ...props
}) => {
  const overlayStyle = {
    overflow: "auto",
  };

  const contentStyle = {
    maxWidth:
      typeof customWidth === "number" ? `${customWidth}px` : customWidth,
  };

  useEffect(() => {
    if (visible) {
      document.body.classList.add("modal-open");
    } else if (
      document.querySelectorAll(".popup-overlay").length <= 1 ||
      !visible
    ) {
      document.body.classList.remove("modal-open");
    }
  }, [visible]);

  const CloseBtn = () => {
    return (
      <>
        <div className="close normal-close" onClick={onClickClose}>
          <Cross size={24} />
        </div>
        <div className="close mobile-close" onClick={onClickClose}>
          <svg
            className="min-w-35px"
            width="35"
            height="35"
            viewBox="0 0 35 35"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M7.18795 27.812C1.4928 22.1168 1.4928 12.8832 7.18795 7.18803C12.8831 1.49288 22.1167 1.49288 27.8119 7.18803C33.507 12.8832 33.507 22.1168 27.8119 27.812C22.1167 33.5071 12.8831 33.5071 7.18795 27.812ZM9.06285 9.06293C4.40319 13.7226 4.40319 21.2774 9.06285 25.9371C13.7225 30.5967 21.2773 30.5967 25.937 25.9371C30.5967 21.2774 30.5967 13.7226 25.937 9.06293C21.2773 4.40326 13.7225 4.40326 9.06285 9.06293ZM12.8127 12.8127C13.3304 12.295 14.1698 12.295 14.6876 12.8127L17.4999 15.6251L20.3123 12.8127C20.83 12.295 21.6694 12.295 22.1872 12.8127C22.7049 13.3305 22.7049 14.1699 22.1872 14.6876L19.3748 17.5L22.1872 20.3124C22.7049 20.8301 22.7049 21.6695 22.1872 22.1873C21.6694 22.705 20.83 22.705 20.3123 22.1873L17.4999 19.3749L14.6876 22.1873C14.1698 22.705 13.3304 22.705 12.8127 22.1873C12.2949 21.6695 12.2949 20.8301 12.8127 20.3124L15.625 17.5L12.8127 14.6876C12.2949 14.1699 12.2949 13.3305 12.8127 12.8127Z"
              fill="white"
            />
          </svg>
        </div>
      </>
    );
  };
  // const disableScroll = () => {
  //   document.body.style.overflow = "hidden";
  // };

  // const enableScroll = () => {
  //   document.body.style.overflow = "auto";
  // };

  return (
    <Popup
      className={`custom-modal ${popUpClass ? popUpClass : ""}`}
      open={visible}
      modal={true}
      closeOnEscape={false}
      closeOnDocumentClick={closeOnDocumentClick}
      overlayStyle={overlayStyle}
      contentStyle={contentStyle}
      ref={customRefProp}
      // onOpen={disableScroll}
      // onClose={enableScroll}
      {...props}
    >
      {showCloseBtn ? <CloseBtn /> : null}
      {children}
    </Popup>
  );
};

export default PopupModal;
